import Page from 'src/showcase/[entityId]/embed2/index';

export default Page;
